{
  "name": "mea2",
  "version": "8.1.4",
  "author": "Ionic Framework",
  "homepage": "https://ionicframework.com/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "build:all:dev": "npm run build:web:dev && npm run build:app:android && npm run build:app:ios",
    "build:all:prod": "npm run build:web:prod && npm run build:app:android:prod && npm run build:app:ios:prod",
    "build:all:qa": "npm run build:web:qa && npm run build:app:android:qa && npm run build:app:ios:qa",
    "build:app:android": "ng run app:build:dev && npx cap sync android && cd ./android && rm -rf ./app/build/outputs/apk/release/* && bundle exec fastlane release",
    "build:app:android:prod": "ng run app:build:production && npx cap sync android && cd ./android && rm -rf ./app/build/outputs/apk/release/* && bundle exec fastlane release",
    "build:app:android:qa": "ng run app:build:qa && npx cap sync android && cd ./android && rm -rf ./app/build/outputs/apk/release/* && bundle exec fastlane release",
    "build:app:ios": "ng run app:build:dev && npx cap sync ios && cd ./ios/App && rm -rf ./App/deploy/* && bundle exec fastlane release",
    "build:app:ios:prod": "ng run app:build:production && npx cap sync ios && cd ./ios/App && rm -rf ./App/deploy/* && bundle exec fastlane release env:prod",
    "build:app:ios:qa": "ng run app:build:qa && npx cap sync ios && cd ./ios/App && rm -rf ./App/deploy/* && bundle exec fastlane release env:qa",
    "build:web:dev": "ng build --configuration=dev --aot",
    "build:web:prod": "ng build --configuration=production --aot",
    "build:web:qa": "ng build --configuration=qa --aot",
    "deploy:all:dev": "npm run deploy:web:dev && npm run deploy:app:android:dev && npm run deploy:app:ios:dev",
    "deploy:all:prod": "npm run deploy:web:prod && npm run deploy:app:android:prod && npm run deploy:app:ios:prod",
    "deploy:all:qa": "npm run deploy:web:qa && npm run deploy:app:android:qa && npm run deploy:app:ios:qa",
    "deploy:app:android:dev": "./deploy -p android -e dev",
    "deploy:app:android:prod": "./deploy -p android -e prod",
    "deploy:app:android:qa": "./deploy -p android -e qa",
    "deploy:app:ios:dev": "./deploy -p ios -e dev",
    "deploy:app:ios:prod": "./deploy -p ios -e prod",
    "deploy:app:ios:qa": "./deploy -p ios -e qa",
    "deploy:web:dev": "./deploy -p web -e dev",
    "deploy:web:prod": "./deploy -p web -e prod",
    "deploy:web:qa": "./deploy -p web -e qa",
    "build+deploy:all:dev": "npm run build:all:dev && npm run deploy:all:dev",
    "build+deploy:all:prod": "npm run build:all:prod && npm run deploy:all:prod",
    "build+deploy:all:qa": "npm run build:all:qa && npm run deploy:all:qa",
    "build+deploy:android:dev": "npm run build:app:android && npm run deploy:app:android:dev",
    "build+deploy:android:prod": "npm run build:app:android:prod && npm run deploy:app:android:prod",
    "build+deploy:android:qa": "npm run build:app:android:qa && npm run deploy:app:android:qa",
    "build+deploy:ios:dev": "npm run build:app:ios && npm run deploy:app:ios:dev",
    "build+deploy:ios:prod": "npm run build:app:ios:prod && npm run deploy:app:ios:prod",
    "build+deploy:ios:qa": "npm run build:app:ios:qa && npm run deploy:app:ios:qa",
    "build+deploy:web:dev": "npm run build:web:dev && npm run deploy:web:dev",
    "build+deploy:web:prod": "npm run build:web:prod && npm run deploy:web:prod",
    "build+deploy:web:qa": "npm run build:web:qa && npm run deploy:web:qa",
    "media:get": "ts-node ./scripts/media.ts",
    "merge-color-config-images:dev": "npm run media:get && ts-node ./scripts/color-config-merge-images.ts && ./scripts/upload_combined_images qa && rm -rf src/assets/media/",
    "merge-color-config-images:prod": "ts-node ./scripts/color-config-merge-images.ts && ./scripts/upload_combined_images prod && rm -rf src/assets/media/",
    "merge-color-config-images:qa": "ts-node ./scripts/color-config-merge-images.ts && ./scripts/upload_combined_images staging && rm -rf src/assets/media/",
    "postinstall": "npx jetify"
  },
  "engines": {
    "node": "~18.19.1",
    "npm": "~10"
  },
  "husky": {
    "hooks": {
      "pre-commit": "pretty-quick --staged"
    }
  },
  "private": true,
  "dependencies": {
    "@angular/common": "19.2.5",
    "@angular/core": "19.2.5",
    "@angular/forms": "19.2.5",
    "@angular/platform-browser": "19.2.5",
    "@angular/platform-browser-dynamic": "19.2.5",
    "@angular/router": "19.2.5",
    "@auth0/auth0-angular": "2.2.3",
    "@awesome-cordova-plugins/background-mode": "6.4.0",
    "@awesome-cordova-plugins/core": "6.1.0",
    "@awesome-cordova-plugins/document-viewer": "6.1.0",
    "@awesome-cordova-plugins/email-composer": "6.2.0",
    "@awesome-cordova-plugins/file-opener": "6.2.0",
    "@capacitor/android": "6.0.0",
    "@capacitor/app": "6.0.0",
    "@capacitor/browser": "6.0.0",
    "@capacitor/core": "6.0.0",
    "@capacitor/filesystem": "6.0.0",
    "@capacitor/haptics": "6.0.0",
    "@capacitor/ios": "6.0.0",
    "@capacitor/keyboard": "6.0.0",
    "@capacitor/network": "6.0.0",
    "@capacitor/preferences": "6.0.0",
    "@capacitor/status-bar": "6.0.0",
    "@ionic/angular": "7.1.1",
    "@jht/brand-translate": "19.14.5",
    "@meddv/ngx-pinch-zoom": "17.0.1",
    "cordova-plugin-background-mode": "0.7.3",
    "cordova-plugin-device": "2.1.0",
    "cordova-plugin-document-viewer": "1.0.0",
    "cordova-plugin-email-composer": "0.10.1",
    "cordova-plugin-file": "7.0.0",
    "cordova-plugin-file-opener2": "3.0.5",
    "dotenv": "16.0.1",
    "merge-images-v2": "2.0.1",
    "mime": "3.0.0",
    "rxjs": "7.8.0",
    "semver": "7.5.3",
    "stream": "0.0.2",
    "timers": "0.1.1",
    "tslib": "2.2.0",
    "xml2js": "0.6.0",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.6",
    "@angular-eslint/builder": "19.3.0",
    "@angular-eslint/eslint-plugin": "19.3.0",
    "@angular-eslint/eslint-plugin-template": "19.3.0",
    "@angular-eslint/template-parser": "19.3.0",
    "@angular/cli": "19.2.6",
    "@angular/compiler": "19.2.5",
    "@angular/compiler-cli": "19.2.5",
    "@angular/language-service": "19.2.5",
    "@capacitor/cli": "6.0.0",
    "@ionic/angular-toolkit": "9.0.0",
    "@ionic/cli": "7.1.1",
    "@ionic/lab": "3.2.13",
    "@types/jasmine": "3.6.0",
    "@types/jasminewd2": "2.0.3",
    "@types/mime": "3.0.1",
    "@types/node": "18.16.18",
    "@typescript-eslint/eslint-plugin": "5.3.0",
    "@typescript-eslint/parser": "5.3.0",
    "eslint": "7.6.0",
    "eslint-plugin-import": "2.22.1",
    "eslint-plugin-jsdoc": "30.7.6",
    "eslint-plugin-prefer-arrow": "1.2.2",
    "husky": "8.0.3",
    "jasmine-core": "3.8.0",
    "jasmine-spec-reporter": "5.0.0",
    "jetifier": "2.0.0",
    "karma": "6.3.2",
    "karma-chrome-launcher": "3.1.0",
    "karma-coverage": "2.0.3",
    "karma-coverage-istanbul-reporter": "3.0.2",
    "karma-jasmine": "4.0.0",
    "karma-jasmine-html-reporter": "1.5.0",
    "prettier": "2.8.6",
    "pretty-quick": "3.1.3",
    "protractor": "7.0.0",
    "sharp": "0.33.3",
    "slugify": "1.6.5",
    "ts-node": "8.3.0",
    "typescript": "5.8.2"
  },
  "description": "An Ionic project"
}
